// @ts-expect-error cannot find  typed file
import { useSearchParam } from '../../hooks/searchParamHooks';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { VIDEO_TIMESTAMP_PARAM } from './videoConstants';
export const useVideoParams = () => {
  const [[startTime]] = useSearchParam(VIDEO_TIMESTAMP_PARAM);
  return {
    startTime: startTime ? Number(startTime) : undefined
  };
};
export const useAutoClearVideoVTS = () => {
  const {
    startTime
  } = useVideoParams();
  const history = useHistory();
  useEffect(() => () => {
    if (startTime) {
      const searchParams = new URLSearchParams(history.location.search);
      searchParams.delete(VIDEO_TIMESTAMP_PARAM);
      history.replace(Object.assign({}, history.location, {
        search: searchParams.toString()
      }));
    }
  }, [history, startTime]);
};
const videoPlayerConfigDefaultState = {
  autoPlay: false,
  playSpeed: 100
};
export const useVideoPlayerConfig = create()(persist(set => Object.assign({}, videoPlayerConfigDefaultState, {
  toggleAutoPlay() {
    set(state => ({
      autoPlay: !state.autoPlay
    }));
  },
  setPlaySpeed(speed) {
    set({
      playSpeed: speed
    });
  },
  setSubtitleLanguage(subtitleLanguage) {
    set({
      subtitleLanguage
    });
  }
}), {
  name: 'academy:videoPreferences'
}));
export const resetVideoPlayerConfig = () => useVideoPlayerConfig.setState(videoPlayerConfigDefaultState);